// A destructive button that asks for a second click instead of a browser dialog.

import { t } from "../i18n/i18n";
import { createButton } from "./dom";

export function createConfirmButton(label: string, onConfirm: () => Promise<void>): HTMLButtonElement {
  let isArmed: boolean = false;
  const button: HTMLButtonElement = createButton(label, async (): Promise<void> => {
    if (isArmed === false) {
      isArmed = true;
      button.textContent = t("admin.deleteConfirm");
      return;
    }

    await onConfirm();
  }, "button-danger");
  return button;
}
